import type { AuthResponse, SignInWithPasswordCredentials } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import {
  MFA_FACTORS_TIMEOUT_MS,
  promiseWithTimeout,
  SIGN_IN_TIMEOUT_MS,
} from "@/utils/promiseWithTimeout";

export const SIGN_IN_TIMEOUT_MESSAGE = "Sign-in timed out. Check your connection and try again.";

export const MFA_FACTORS_TIMEOUT_MESSAGE =
  "Could not verify two-factor authentication status. Please try again.";

export function signInWithPasswordTimed(
  credentials: SignInWithPasswordCredentials,
  timeoutMs = SIGN_IN_TIMEOUT_MS
): Promise<AuthResponse> {
  return promiseWithTimeout(
    supabase.auth.signInWithPassword(credentials),
    timeoutMs,
    SIGN_IN_TIMEOUT_MESSAGE
  );
}

export function listMfaFactorsTimed(timeoutMs = MFA_FACTORS_TIMEOUT_MS) {
  return promiseWithTimeout(
    supabase.auth.mfa.listFactors(),
    timeoutMs,
    MFA_FACTORS_TIMEOUT_MESSAGE
  );
}
